import { render, staticRenderFns } from "./Reset.html?vue&type=template&id=fd1f308a&scoped=true&"
import script from "./Reset.ts?vue&type=script&lang=ts&"
export * from "./Reset.ts?vue&type=script&lang=ts&"
import style0 from "./Reset.scss?vue&type=style&index=0&id=fd1f308a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1f308a",
  null
  
)

export default component.exports